import _ from 'lodash'
import Backbone from 'backbone'
import $ from 'jquery'
import AllTags from '../../components/all-tags'
import conductor from 'scoreboard/components/conductor'
import basicInfo from 'scoreboard/components/overview-info/basic-info.hbs'
import scorecardInfo from './scorecard-info.hbs'
import templateCopies from 'scoreboard/components/overview-info/template-copies.hbs'
import datasetSeriesDrilldown from 'scoreboard/datasets/overview/dataset-series-drilldown'
import equationSeriesDetail from './equation-series-detail.hbs'
import TooltipAndDetails from 'scoreboard/components/tooltip-and-details'
import context from './scorecards-context'
import template from './scorecards-overview-info.hbs'
import deviceType from 'scoreboard/components/device-type'
import globals from 'scoreboard/components/globals'
import treeIdsInFilters from 'scoreboard/datasets/tree-ids-in-filters'
import appDisplay from 'scoreboard/components/app-display'
import RelatedItemsList from 'scoreboard/related-items/related-items-list'
import i18n from 'scoreboard/components/i18n'
import calendars from 'scoreboard/components/calendars'
import config from 'scoreboard/components/config'
import GenericOverviewInfo from 'scoreboard/components/overview-info/generic-overview-info'
import linkedNodesTemplate from './linked-nodes.hbs'

/**
 * this.model is a ScorecardNode
 */
var ScorecardsOverviewInfo = GenericOverviewInfo.extend({

	className: 'overview-info',

	events: {
		'click .reference': 'reference',
		'click .source': 'close',
		'click .tags-panel .badge': 'displayTags',
		'click .equation': 'clickEquation'
	},

	render: function() {
		var ctx = context(this.model)
		this.gatherTemplateInformation(ctx)

		this.$el.empty().append(template(ctx))
		this.$('.basic-info').replaceWith(basicInfo(ctx))
		this._renderScorecardInfo(ctx)
		this.$('.template-copies').replaceWith(templateCopies(ctx))

		this.relatedItemsList = new RelatedItemsList({ model: this.model })
		this.$('.related').html(this.relatedItemsList.el)
		this.relatedItemsList.render()

		let linkedNodes = this.model.get('linkedNodes')
		this.$('.linked')
			.toggleClass('is-not-displayed', !linkedNodes)
			.html(linkedNodesTemplate({
				title: i18n.get('scorecards.overview.linkedToThis', ctx.typeText),
				items: linkedNodes
			}))

		// Wait till the relevant pieces are in the DOM before applying details tooltips
		this.equationTooltips = []
		process.nextTick(() => {
			// Tooltip for the template
			let template = this.model.get('template')
			if (template && template.organization) {
				this._applyDetailsTooltip({
					selector: this.$('.value .template-id'),
					tooltipContent: e => {
						return equationSeriesDetail({
							value: template.organization.label,
							detail: deviceType.touchOnly ? e.target.getAttribute('data-details-link') : null
						})
					},
					details: e => conductor.navigate(e.target.dataset.detailsLink, {trigger: true})
				})
			}

			// Tooltip for the source KPI
			this._applyDetailsTooltip({
				selector: this.$('.list .value.source'),
				tooltipContent: e => {
					return new Promise((resolve, reject) => {
						let orgId = e.target.dataset.sourceOrganizationId
						$.get(`api/organizations/${orgId}`, sourceOrg => {
							if (sourceOrg) {
								resolve(equationSeriesDetail({
									value: sourceOrg.label,
									detail: deviceType.touchOnly ? e.target.getAttribute('data-details-link') : null
								}))
							} else {
								reject()
							}
						}).fail(() => {
							reject()
						})
					})
				},
				details: e => conductor.navigate(e.target.dataset.detailsLink, { trigger: true })
			})

			// Tooltips for series
			if (calendars.periodsById[globals.periodId].calendar.id == this.model.get('calendarId')) {
				this._createTooltipsForSeries()
			}
		})

		return this
	},

	_renderScorecardInfo: function(ctx) {
		const series = this.model.get('series')
		let i = 0
		ctx.series = _.map(series, s => {
			let contextSeries = ctx.series[i]
			i++
			const seriesLabel = this.model.getDatasetSeriesLabel(s)
			if (seriesLabel) {
				_.extend(contextSeries, {equation: seriesLabel})
			}
			return contextSeries
		})
		this.$('.scorecard-info').replaceWith(scorecardInfo(ctx))
	},

	_createTooltipsForSeries: function () {
		_.each(this.$('.equation'), el => this._applyDetailsTooltip({
			selector: this.$(el).find('.reference'),
			tooltipContent: e => {
				return new Promise((resolve, reject) => {
					let seriesKey = this.$(e.target)
						.closest('.info-item.equation-viewer')
						.data('seriesKey')

					$.ajax({
						url: `api/scorecards/${this.model.id}/data-used-in-calculations`,
						method: 'POST',
						data: JSON.stringify({
							calendarPeriodId: globals.periodId,
							series: seriesKey
						})
					}).done(data => {
						let collection = e.target.dataset.type === 'initiative' ? 'initiatives' : 'scorecardItems'
						let id = e.target.dataset.id
						let label = data[collection][e.target.dataset.id].label
						// #29064 display the organization the metric comes from
						let org = data[collection][e.target.dataset.id].organizationLabel
						resolve(equationSeriesDetail({
							id: id,
							label: label,
							organization: org,
							displayIds: config.displayIds,
							detail: deviceType.touchOnly ? e.target.getAttribute('data-type') : null,
							detailId: deviceType.touchOnly ? e.target.getAttribute('data-id') : null
						}))
					}).fail(() => {
						reject()
					})
				})
			},
			details: e => {
				var section = e.target.dataset.detailsLink === 'initiative' ? 'initiatives' : 'scorecards'
					,	id = e.target.dataset.detailsId

				if (id) {
					conductor.overview(section, id)
				}

				this.close()
			}
		}))
	},

	_applyDetailsTooltip: function({selector, tooltipContent, details}) {
		this.equationTooltips.push(new TooltipAndDetails({
			selector,
			tooltipContent,
			details,
			tooltipOptions: {
				extraClass: 'equation-value-tooltip',
				placement: 'above'
			}
		}))
	},

	close: function() {
		this.trigger('done')
	},

	displayTags: AllTags.display,

	reference: function(e) {
		var ref = this.$(e.target)
		var id = parseInt(ref.data('id'))
		var section = ref.data('type') === 'initiative' ? 'initiatives' : 'scorecards'
		this.trigger('done')
		// #9244 the ID can be undefined, in which case it's a reference to the
		// current metric and we don't need to go anywhere
		if (id) {
			conductor.overview(section, id)
		}
	},

	clickEquation: function(e) {
		let index = this.$(e.target).closest('.info-item.equation-viewer')
			.index()
		let series = this.model.get('series')[index]
		if (series.updateType !== 'dataset' || this.model.replicated()) {
			return
		}

		let datasetSeries = JSON.parse(series.equation)
		let treeItemIds = treeIdsInFilters(datasetSeries.filters)
		let xhr = $.get(`api/scorecards/${this.model.id}/dataset-series`, {
			fields: true,
			treeItemIds,
			linkedDatasets: true
		})
		this.trigger('done')
		appDisplay.display(xhr, ({ datasetSeries }) => {
			datasetSeriesDrilldown(datasetSeries[series.key])
		})
	},

	remove: function() {
		Backbone.View.prototype.remove.apply(this, arguments)
		_.invokeMap([this.relatedItemsList, ...this.equationTooltips], 'remove')
	}

})


export default ScorecardsOverviewInfo

ScorecardsOverviewInfo.__filename__ = 'scorecards/overview/scorecards-overview-info.js'
